import React from 'react';
import { AppBar } from '@brighterionai/br-ui';

// make it a constant in case they want to move into some config based
export const TABS = (RoleService: RoleService) => [
    {
        displayName: 'Search',
        route: '/search',
        showFeature: RoleService.hasWLSSingleEntity && !RoleService.isLandlord
    },
    {
        displayName: 'Batch Screening',
        route: '/batch-screening',
        showFeature: RoleService.hasWLSBatchEntity && !RoleService.isLandlord
    },
    {
        displayName: 'Tenants',
        route: '/tenants',
        showFeature: RoleService.isLandlord
    },
    {
        displayName: 'Internal Lists',
        route: '/lists',
        showFeature: RoleService.hasWLSListAdminAccess && !RoleService.isLandlord
    },
    {
        displayName: 'Configuration',
        route: '/configuration',
        showFeature: RoleService.hasWLSConfigAdminAccess && !RoleService.isLandlord
    }
];

const MenuTab = React.memo(
    ({
        route,
        displayName,
        isActive,
        onClick
    }: {
        route: string;
        displayName: string;
        isActive: boolean;
        onClick: () => void;
    }) => {
        return (
            <AppBar.MenuItem
                active={isActive}
                key={route}
                id={`navlink-${route}`}
                onClick={() => {
                    onClick();
                }}
                data-testid={`menu-tab-${route}`}
            >
                {displayName}
            </AppBar.MenuItem>
        );
    }
);

export default MenuTab;
